export const evaluationOptOutCookieName = 'evaluation_opt_out'

export const evaluationOptOutDurationInDays = 30

export const dayInMilliseconds = 24 * 60 * 60 * 1000
